import { useEffect, useMemo, useState } from 'react';

import { useApiClient } from '@eluve/api-client-provider';
import { AudioPlayer } from '@eluve/audio-player';
import { Stack, Text } from '@eluve/components';

interface AppointmentAudioProps {
  appointmentId: string;
  tenantId: string;
}

export const AppointmentAudio: React.FC<AppointmentAudioProps> = ({
  appointmentId,
  tenantId,
}) => {
  const client = useApiClient();
  const [audioUrl, setAudioUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAudioUrl = async () => {
      setIsLoading(true);
      const response = await client.reviewer.getAppointmentAudioFileSignedUrl({
        params: { appointmentId, tenantId },
      });
      if (response.status === 200) {
        const { presignedUrl } = response.body;
        setAudioUrl(presignedUrl);
      }

      setIsLoading(false);
    };

    fetchAudioUrl();
  }, [appointmentId, tenantId, client]);

  const audioPlayer = useMemo(() => {
    if (isLoading) {
      return (
        <Stack className="p-4" align="center" gap={2}>
          <Text color="tertiary">Loading audio...</Text>
        </Stack>
      );
    }

    if (!audioUrl) {
      return (
        <Stack className="p-4" align="center" gap={2}>
          <Text color="tertiary">No audio available for this appointment</Text>
        </Stack>
      );
    }
    return <AudioPlayer audioUrl={audioUrl} className="w-full px-4" />;
  }, [audioUrl, isLoading]);

  return audioPlayer;
};
